import React from 'react'
import './ErrorDialog.css'

type ErrorDialogProps = {
  isOpen: boolean
  onClose: () => void
  title?: string
  description?: string
  supportUrl?: string
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  isOpen,
  onClose,
  title,
  description,
  supportUrl = '/support',
}) => {
  if (!isOpen) return null

  return (
    <div
      className="error-dialog__overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-desc"
        className="error-dialog__container"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="error-dialog-title" className="error-dialog__title">
          {title || 'An error occurred'}
        </h2>
        <p id="error-dialog-desc" className="error-dialog__description">
          {description || 'Something went wrong.'}
          Please contact{' '}
          <a href={supportUrl} target="_blank" rel="noopener noreferrer">
            support
          </a>{' '}
          if the problem persists.
        </p>
        <button onClick={onClose} className="error-dialog__button">
          Close
        </button>
      </div>
    </div>
  )
}
